import { formatearMontoPesos } from "../../../utils/CurrencyUtil";

export const PRECERTIFICACION_WARNING = {
  CONFIRMAR:
    "Es imprescindible confirmar la precertificación, en caso contrario no podrá realizar el reclamo.",
  CANCELAR: "Al cancelar la precertificación no se puede volver a activar.",
};

export const MOCK_DETALLE_PRECERTIFICACION = [
  {
    nombre: "1 - ACIDO URICO",
    codigo: "2",
    frecuencia: "1",
    montoReclamado: "155.25",
    montoARS: "124.20",
    montoAfiliado: "31.05",
  },
  {
    nombre: "1 - AMILASA",
    codigo: "2938",
    frecuencia: "1",
    montoReclamado: "202.00",
    montoARS: "161.60",
    montoAfiliado: "40.40",
  },
];

export const ESTADO_PRECERTIFICACION = {
  VIGENTE: "VIGENTE",
  CANCELADA: "CANCELADA",
  CONVERTIDA: "CONVERTIDA",
};

export const columnsDetallePrecertificacion = (empresa) => {
  return [
    {
      key: "nombre",
      title: "Examen",
      dataIndex: "nombre",
    },
    {
      key: "codigo",
      title: "Código",
      dataIndex: "codigo",
    },
    {
      key: "frecuencia",
      title: "Frecuencia",
      dataIndex: "frecuencia",
    },
    {
      key: "montoReclamado",
      title: "Reclamado",
      dataIndex: "montoReclamado",
      render: (text) => formatearMontoPesos(String(text)),
    },
    {
      key: "montoARS",
      title: "ARS",
      dataIndex: "montoARS",
      render: (text) => formatearMontoPesos(String(text)),
    },
    {
      key: "montoAfiliado",
      title: empresa?.TIPO_CLIENTE,
      dataIndex: "montoAfiliado",
      render: (text) => formatearMontoPesos(String(text)),
    },
  ];
};

export const getFooterPosition = (showDetail) => {
  return showDetail ? "relative" : "fixed";
};

export const getFooterWidth = (showDetail) => {
  return showDetail ? "auto" : "100%";
};
